import hc_smooth_scroll from '@iris.interactive/handcook/public/scripts/components/smooth-scroll/smooth-scroll.component'

export default class HomeService {
    constructor() {
        $('[data-trigger="wpet-agenda-period"]').on('click', function (e) {
            e.preventDefault()
            const val = $(this).attr('data-value')
            $('[name="wpet_search[period][list]"]').val(val)
            $(this).parents('form').submit()
        })

        hc_smooth_scroll()
    }
}
